import { Box, Button, Grid2, Modal, Typography } from "@mui/material";
import { ArrowsOut, CheckSquareOffset, Gauge, Medal } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { fget } from "../../../../API/callsAPI";
import commonStyles from "../../../../Utils/commonStyles";
import ExpandedViewOfUserScoreModal from "./ExpandedViewOfUserScoreModal";
import userScoreStyles from "./UserScoreStyles";

const UserScoreWidget = ({ projectId, userRoleForProject, loggedInUser }) => {
  const commonClasses = commonStyles();
  const classes = userScoreStyles();
  const [userScore, setUserScore] = useState({});
  const [isExpandedViewOpen, setIsExpandedViewOpen] = useState(false);
  const getUserScore = async () => {
    try {
      const res = await fget({
        url: `user-score/?project=${projectId}`,
      });
      setUserScore(res?.data?.results[0] ?? {});
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserScore();
  }, []);

  return (
    <Box className={commonClasses.smallWidgetRoot}>
      <Box className={commonClasses.widgetTitleContainer}>
        <Box className={commonClasses.flexAndGap8Px}>
          <Gauge size={22} weight="fill" color="#6C65D9" />
          <Typography className={commonClasses.widgetsTitle}>
            User Score
          </Typography>
        </Box>
        <div className={commonClasses.flexAndGap8Px}>
          {/* <PencilLine size={20} color="gray" /> */}
          {/* <Trash size={20} color="gray" /> */}
          <Button
            onClick={() => setIsExpandedViewOpen(true)}
            sx={{ minWidth: "0px", padding: "0px", color: "white" }}
          >
            <ArrowsOut size={20} />
          </Button>
        </div>
      </Box>
      <Box
        sx={{
          backgroundColor: "#1F222E",
          padding: "10px",
          borderRadius: "10px",
          height: "156px",
        }}
      >
        <Grid2 container spacing={1} width="100%">
          <Grid2 size={4} bgcolor="#252A38" pt={2} borderRadius="5px">
            <Typography textAlign="center">My Score</Typography>
            <Box
              className={commonClasses.flexCenter}
              sx={{
                backgroundColor: "#6C65D9",
                width: "100%",
                height: "80px",
                borderRadius: "0px 0px 5px 5px",
                gap: "10px",
                mt: 2,
              }}
            >
              <Gauge size={30} weight="fill" fill="white" />
              <Typography
                fontWeight={600}
                fontSize={{ lg: "30px", md: "28px", sm: "24px" }}
              >
                {userScore?.score ?? 0}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={4} bgcolor="#252A38" pt={2} borderRadius="5px">
            <Typography textAlign="center">Ranking</Typography>
            <Box
              className={commonClasses.flexCenter}
              sx={{
                backgroundColor: "#6C65D930",
                width: "100%",
                height: "80px",
                borderRadius: "0px 0px 5px 5px",
                gap: "10px",
                mt: 2,
              }}
            >
              <Medal size={30} fill="white" />
              <Typography
                fontWeight={600}
                fontSize={{ lg: "30px", md: "28px", sm: "24px" }}
              >
                {userScore?.project_ranking}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={4} bgcolor="#252A38" pt={2} borderRadius="5px">
            <Typography textAlign="center">Tasks</Typography>
            <Box
              className={commonClasses.flexCenter}
              sx={{
                backgroundColor: "#6C65D930",
                width: "100%",
                height: "80px",
                borderRadius: "0px 0px 5px 5px",
                gap: "10px",
                mt: 2,
              }}
            >
              <CheckSquareOffset size={30} fill="white" />
              <Typography
                fontWeight={600}
                fontSize={{ lg: "30px", md: "28px", sm: "24px" }}
              >
                {userScore?.tasks_score ?? 0}
              </Typography>
            </Box>
          </Grid2>

          {/* <Grid2 size={4}>
              <Box
                className={commonClasses.flexCenter}
                bgcolor="#252A38"
                py={2}
                borderRadius="5px"
                gap="10px"
              >
                <Gift size={22} />
                <Typography
                  sx={{
                    fontSize: "16px !important",
                  }}
                >
                  {userScore?.gifts_score ?? 0}
                </Typography>
              </Box>
            </Grid2> */}
        </Grid2>
        {/* <div className={commonClasses.flexAndGap8Px} style={{ gap: "10px" }}>
          <div>
            <Typography fontWeight={600} className={classes.keepUp}>
              Keep It Up!
            </Typography>
            <p>You are in the upper 50% of users in this project</p>
          </div>
        </div>
        <Grid2 container spacing={2} mt={2}>
          <Grid2 size={4}>
            <Box
              className={commonClasses.flexCenter}
              bgcolor="#252A38"
              py={2}
              borderRadius="5px"
              gap="10px"
            >
              <Medal size={22} />
              <Typography
                sx={{
                  fontSize: "16px !important",
                }}
              >
                {getNumberWithSuffix(userScore?.project_ranking)}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={4}>
            <Box
              className={commonClasses.flexCenter}
              bgcolor="#252A38"
              py={2}
              borderRadius="5px"
              gap="10px"
            >
              <CheckSquareOffset size={22} />
              <Typography
                sx={{
                  fontSize: "16px !important",
                }}
              >
                {userScore?.tasks_score ?? 0}
              </Typography>
            </Box>
          </Grid2>
          <Grid2 size={4}>
            <Box
              className={commonClasses.flexCenter}
              bgcolor="#252A38"
              py={2}
              borderRadius="5px"
              gap="10px"
            >
              <Gift size={22} />
              <Typography
                sx={{
                  fontSize: "16px !important",
                }}
              >
                {userScore?.gifts_score ?? 0}
              </Typography>
            </Box>
          </Grid2>
        </Grid2> */}
      </Box>
      <Modal
        open={isExpandedViewOpen}
        className={commonClasses.flexCenter}
        onClose={() => setIsExpandedViewOpen(false)}
      >
        <ExpandedViewOfUserScoreModal
          projectId={projectId}
          handleClose={() => setIsExpandedViewOpen(false)}
          userRoleForProject={userRoleForProject}
          loggedInUser={loggedInUser}
        />
      </Modal>
    </Box>
  );
};

export default UserScoreWidget;
